import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  jobCatalogDescription?: string | null
}

const RoleDescription = ({ jobCatalogDescription }: Props) => {
  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {i18n.t('contract_versions.job_position.role_description')}
      </Text>
      {jobCatalogDescription && (
        <Text size="300" weight="medium" color="grey1000">
          <div dangerouslySetInnerHTML={{ __html: jobCatalogDescription }} />
        </Text>
      )}
      {!jobCatalogDescription && (
        <Text size="300" weight="medium" color="grey600">
          {i18n.t('contract_versions.job_position.not_informed')}
        </Text>
      )}
    </Box>
  )
}
export default RoleDescription
